<template>
	<div dir="rtl" class="container">
		<div class="inner-container font-family-custom">
			<HeaderImage styleImage="small-image" image="/image_huji_reunion.jpeg" />
			<Invitation />
			<br />
			<br />
			<form @submit.prevent="submit">
        <div class="row-container" style="margin-top: 40px;">
					<div class="flex name-container">
						<p>שם</p>
					</div>
					<div class="input-container">
						<input 
							v-model="form.data.contact_details.fields.full_name.value" 
							type="text" 
							class="full-width"
							:class="{ error: form.data.contact_details.fields.full_name.has_error }" 
							@focus="form.data.contact_details.fields.full_name.has_error = false"
							>
					</div>
				</div>

				<div class="row-container">
					<div class="flex name-container">
						<p>מספר טלפון</p>
					</div>
					<div class="input-container">
						<input 
							v-model="form.data.contact_details.fields.phone_number.value" 
							type="text" 
							class="full-width"
							:class="{ error: form.data.contact_details.fields.phone_number.has_error }" 
							@focus="form.data.contact_details.fields.phone_number.has_error = false"
						>
					</div>
				</div>
				<div class="row-container">
					<div class="flex name-container">
						<p>דואר אלקטרוני</p>
					</div>
					<div class="input-container">
						<input 
							v-model="form.data.contact_details.fields.email.value" 
							type="text" 
							class="full-width"
							:class="{ error: form.data.contact_details.fields.email.has_error }" 
							@focus="form.data.contact_details.fields.email.has_error = false"
						>
					</div>
				</div>
				<div class="row-container">
					<div class="flex name-container">
						<p>מה את/ה עושה בימינו?</p>
					</div>
					<div class="input-container">
						<textarea v-model="form.data.contact_details.fields.occupation.value" class="full-width" rows="5"></textarea>
					</div>
				</div>
        <div class="row-container">
					<div class="flex name-container">
						<p>מה הדבר הכי מעניין / מגניב / מוזר שקרה לך אחרי סיום הלימודים ועד היום?</p>
					</div>
					<div class="input-container">
						<textarea v-model="form.data.contact_details.fields.bizarre.value" class="full-width" rows="5"></textarea>
					</div>
				</div>
        <div class="row-container">
          <div class="flex name-container">
						<p>איך את/ה אוהב/ת את הפיצה שלך?</p>
					</div>
          <div class="input-container">
            <div class="field">
              <div class="control">
                <label class="radio width-30per">
                  <input class="input-radio" type="radio" value="רגילה" v-model="form.data.contact_details.fields.pizza.value">
                  רגילה
                </label>
                <label class="radio width-30per">
                  <input class="input-radio" type="radio" value="טבעונית" v-model="form.data.contact_details.fields.pizza.value">
                  טבעונית
                </label>
                <label class="radio width-30per">
                  <input class="input-radio" type="radio" value="ללא גלוטן" v-model="form.data.contact_details.fields.pizza.value">
                  ללא גלוטן
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
				<div class="flex flex-justify-center">
					<button class="submit-button" type="submit" :class="{ is_submitting: is_submittng }">ניפגש!</button>
				</div>
			</form>
			<div class="mt-5 has-text-weight-bold">
				<p>
					תודה רבה לנותני החסות לאירוע:
				</p>
			</div>
			<div class="flex is-flex-wrap-wrap is-justify-content-center mt-5">
				<figure class="image is-64x64">
					<img width="64" src="/faculty_law_logo.jpeg">
				</figure>
				<figure class="image is-64x64">
					<img width="64" src="/herzog_logo.jpeg">
				</figure>
				<figure class="image is-64x64">
					<img width="64" src="/huji_law_logo.jpeg">
				</figure>
				<figure class="image is-64x64">
					<img width="64" src="/suitup_logo_dark.png">
				</figure>
			</div>
		</div>
	</div>
</template>
<script>
	import Invitation from '@/components/InvitationHujiClassReunion'
	import HeaderImage from '@/components/HeaderImage'

	import { mapActions } from 'vuex'
	import Form from '@/classes/form.js' 
	export default {
		name: 'home',
		components: {
			Invitation,
			HeaderImage
		},
		data(){
			return {
				is_submittng: false,
				form: new Form({
			  	contact_details: {
						fields: {
							full_name: {
								value: '',
								has_error: false,
								validations: ['Exists']
							},
							email: {
								value: '',
								has_error: false,
								validations: ['Email']
							},
							phone_number: {
								value: '',
								has_error: false,
								validations: ['Exists']
							},
							occupation: {
								value: '',
								has_error: false,
								validations: []
							},
							bizarre: {
								value: '',
								has_error: false,
								validations: []
							},
              pizza: {
                value: 'רגילה',
								has_error: false,
								validations: []
              }
						},
						request_details: {
							method: 'post',
							url: 'https://suitupapi.club/general_notify/',
							headers: { accept: 'applicant api; version=1' },
							extra_data: {
								title: 'מפגש מחזור HUJI 26/06/2022',
								is_submit_click: false
							}
						},
						is_used: true
			        }
		      	})
			}
		},
		methods: {
			...mapActions('toast', ['showToast']),
			submit(){
				if(!this.form.validate()){
					return
				}
				this.form.data.contact_details.request_details.extra_data.is_submit_click = true
				const { full_name } = this.form.data.contact_details.fields
				const { title } = this.form.data.contact_details.request_details.extra_data
				this.form.data.contact_details.request_details.extra_data.title = `${full_name.value} - ${title}`
				let response = this.form.callServer()
				this.is_submittng = true
				response.promise.then(() => {
					this.is_submittng = false
					this.clearForm()
					this.showToast({ text: 'נתראה ב-26/6 :))', type: 'success', delay: 4200 })
				})
			},
			clearForm(){
				this.form.data.contact_details.request_details.extra_data.is_submit_click = false
				for(let key in this.form.data.contact_details.fields){
					this.form.data.contact_details.fields[key].value = ''
				}
			},
		}
	}
</script>
<style scoped>

  input[type="checkbox"],
  input[type="radio"] {
    vertical-align: baseline;
  }
  .checkbox, .radio {
    cursor: pointer;
    display: inline-block;
    line-height: 1.25;
    position: relative;
  }
  .checkbox input, .radio input {
    cursor: pointer;
  }
  .checkbox:hover, .radio:hover {
    color: #363636;
  }
  .checkbox[disabled], .radio[disabled],
  fieldset[disabled] .checkbox,
  fieldset[disabled] .radio,
  .checkbox input[disabled],
  .radio input[disabled] {
    color: #7a7a7a;
    cursor: not-allowed;
  }
  .radio + .radio {
    margin-left: 0.5em;
  }
  .control {
    box-sizing: border-box;
    clear: both;
    font-size: 1rem;
    position: relative;
    text-align: inherit;
  }
  .label {
  color: #363636;
  display: block;
  font-size: 1rem;
  font-weight: 700;
  }
  .label:not(:last-child) {
    margin-bottom: 0.5em;
  }
  .label.is-small {
    font-size: 0.75rem;
  }
  .label.is-medium {
    font-size: 1.25rem;
  }
  .label.is-large {
    font-size: 1.5rem;
  }
  .width-30per {
    width: 30%;
  }
  
	p {
		margin: 0;
	}
	.container {
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: right;
		margin-bottom: 50px;
	}
	.inner-container {
    background-color: white;
		max-width: 800px;
		border:  2px solid #f2f2f2;
		padding: 20px 60px;
		box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	}
	.flex {
		display: flex;
	}
	.flex-align-center {
		align-items: center;
	}
	.flex-justify-center {
		justify-content: center;
	}
	.row-container {
		display: flex;
		margin-bottom: 30px;
	}
	.row-container p {
		text-align: right;
		font-weight: 600;
	}
	.mandatory-indiciation {
		color: red;
	}
	textarea, input {
		padding: 4px 8px;
		border: 1px solid rgba(0, 0, 0, 0.2);
	}
	.placeholder {
		margin-top: 5px;
		color: #777;
		font-size: 15px;
	}
	.name-container {
		margin-left: 20px;
		width: 200px;
	}
	.full-width {
		width: 100%;
	}
	.input-container {
		width: 450px;
	}
	input {
		width: 100%;
	}
  .input-radio {
    width: inherit
  }
	textarea, input {
		box-sizing: border-box;
	}
	.disclaimer {
		margin-top: 2px;
		font-size: 12px;
		color: #999;
		font-weight: 400;
	}
	.submit-button {
		cursor: pointer;
		font-size:  15px;
		font-weight: 600;
		border:  none;
		outline: none;
		color:  white;
		padding: 5px 20px;
		background-color: #0099e5;
		margin-bottom: 10px;
	}
	.is_submitting {
		opacity: 0.5;
		pointer-events: none;
	}
	.error {
		border-color: red;
	}
    @media only screen and (max-width: 800px) {
    	.row-container {
    		flex-direction: column;
    	}
    	.input-container {
    		width: 100%;
    	}
    	.name-container {
    		margin-left: 0;
    		margin-bottom: 2px;
    	}
    	.container {
    		margin-top: 0;
    		margin-bottom: 0;
    	}
    	.inner-container {
    		padding: 20px;
    		margin: 5px;
    		margin-top: 5px;
    	}
      .name-container {
		    margin-left: 20px;
        margin-bottom: 0.8rem;
		    width: 100%;
	    }
      .radio {
        display: block;
        width: 70%;
        margin-bottom: 0.8rem;
      }
      .input-radio {
        width: 20%;
      }
      .control {
        margin-top: 1.2rem;
      }
    }



</style>